(function() {
    const multiStepForms = document.querySelectorAll('.js-multi-step-form-dfe');
    
    if (multiStepForms.length === 0) return;

    const fireCustomEvent = (stepNumber, action) => {
        customEvent("Form", {
            currentStep: stepNumber,
            action: action,
            location: "Modal",
            microIgnore: false
        });
    };

    multiStepForms.forEach(form => {
        const formSteps = form.querySelectorAll('.form-step');
        let currentStep = 1;
        const progressBar = document.querySelector('.progress-bar');
        const hiddenField = form.querySelector("[name=requested_service_detail]");

        document.addEventListener('click', (e) => {
            if (e.target.closest('.js-modal-radio')) {
                setUpRadioListeners(e);
            }

            const inlineLegal = document.querySelector('.cta__bottom');

            if (e.target.closest('.cta__bottom') || e.target.closest('.legal-trigger')){
                inlineLegal?.classList.add('is-active');
            }

            if(e.target.closest('.js-closeDFE')) {
                inlineLegal?.classList.remove('is-active');
                fireCustomEvent(currentStep, `Close`);
            }
        });

        const transitionStep = (currentStep, nextStep, isBackward = false) => {
            const skipTransition = formSteps[currentStep - 1].dataset.skipTransition === "true" || isBackward;

            if (!skipTransition) {
                form.classList.toggle('c-form--submitting');
            }

            setTimeout(() => {
                formSteps[currentStep - 1].style.display = 'none';
                formSteps[nextStep - 1].style.display = 'block';

                if (!skipTransition) {
                    form.classList.toggle('c-form--submitting');
                }
            }, skipTransition ? 0 : 1500);
        };

        const areInputsValid = (step) => {
            const inputs = formSteps[step - 1].querySelectorAll('input, select');
            return Array.from(inputs).every(input => input.checkValidity());
        };

        const triggerHtml5Validation = () => {
            form.querySelector('button[type="submit"]').click();
        };

        const updateHiddenField = (step) => {
            const currentStepElement = formSteps[step - 1];
            const checkboxes = currentStepElement.querySelectorAll('input[type="checkbox"]:checked');
            const errorParagraph = currentStepElement.querySelector('.js-checkbox-error');

            if (!validateAndShowError(checkboxes, errorParagraph)) {
                return false;
            }

            updateHiddenInput(checkboxes);
            return true;
        };

        const validateAndShowError = (checkboxes, errorParagraph) => {
            const isValid = checkboxes.length > 0;
            if (errorParagraph) {
                errorParagraph.style.display = isValid ? 'none' : 'block';
            }
            return isValid;
        };

        const updateHiddenInput = (checkboxes) => {
            const selectedValues = Array.from(checkboxes).map(cb => cb.value);
            hiddenField.value = selectedValues.join(', ');
        };

        const nextStep = () => {
            if (!areInputsValid(currentStep)) {
                triggerHtml5Validation();
                return;
            }
            if (!updateHiddenField(currentStep)) {
                return;
            }
            transitionStep(currentStep, currentStep + 1);
            updateStepCounter(currentStep + 1);
            calculateProgress(currentStep);
            fireCustomEvent(currentStep + 1, `Step ${currentStep} Success`);
            currentStep++;
        };

        const prevStep = () => {
            transitionStep(currentStep, currentStep - 1, true);
            updateStepCounter(currentStep - 1);
            calculateProgress(currentStep, false);
            fireCustomEvent(currentStep - 1, `Step ${currentStep - 1} Backward`);
            currentStep--;
        };

        const setUpRadioListeners = (e) => {
            const currentStepNumber = Number(e.target.closest('.form-step').dataset.step);

            if (e.target.classList.contains('js-radio-effect')) {
                form.querySelector("[name='effect']").value = e.target.value;
            }

            updateStepCounter(currentStepNumber + 1);
            calculateProgress(currentStepNumber);
            fireCustomEvent(currentStepNumber + 1, `Step ${currentStepNumber} Success`);
            transitionStep(currentStepNumber, currentStep + 1);
            currentStep++;
        };

        const calculateProgress = (currentStepNumber, isForward = true) => {
            const stepCount = form.querySelectorAll('.form-step').length;
            const currentStep = isForward ? +currentStepNumber + 1 : +currentStepNumber - 1;
            const progress = (currentStep / stepCount) * 100;
            progressBar.style.width = progress + '%';
        };

        const updateStepCounter = (stepNumber) => {
            document.querySelector('.step-counter #current-step').innerHTML = stepNumber;
        };

        const buttonActions = {
            'next_step': nextStep,
            'previous_step': prevStep
        };

        form.querySelectorAll('button[data-step]').forEach(button => {
            const action = buttonActions[button.name];
            if (action) {
                button.addEventListener('click', action);
            }
        });

        calculateProgress(2, false);
    });
})();
